import React from 'react';

const CheckIcon = ({
	stroke = 'white',
	...props
}: {
	stroke?: string;
	className?: string;
	style?: React.CSSProperties;
}) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			fill="none"
			stroke={stroke}
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
			style={props.style}
			className={props.className}
		>
			<polyline points="20 6 9 17 4 12"></polyline>
		</svg>
	);
};

export default CheckIcon;
